import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Row, Col, Container } from 'components';
import { Margin } from 'styled-components-spacing/dist/cjs';
import {
  CONSENT_EVENT,
  acceptCookies,
  hasConsentDecision,
  rejectCookies,
} from 'helpers/cookieConsent';
import { Wrapper, Text, Actions, AcceptButton, RejectButton } from './Cookie.styled';

const Cookie = () => {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setVisible(!hasConsentDecision());

    const openBanner = () => setVisible(true);

    window.addEventListener(CONSENT_EVENT, openBanner);

    return () => window.removeEventListener(CONSENT_EVENT, openBanner);
  }, []);

  const handleAccept = () => {
    acceptCookies();
    setVisible(false);
  };

  const handleReject = () => {
    rejectCookies();
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <Wrapper role="dialog" aria-label={t('global.cookie.title')} aria-live="polite">
      <Container>
        <Row>
          <Col size={{ lg: 3 / 4 }}>
            <Text>
              {t('global.cookie.description')}{' '}
              <Link to="/cookie-policy">{t('global.cookie.policyLink')}</Link>
            </Text>
          </Col>
          <Col size={{ lg: 1 / 4 }}>
            <Margin top={{ xs: 12, lg: 0 }}>
              <Actions>
                <RejectButton type="button" onClick={handleReject}>
                  {t('global.cookie.reject')}
                </RejectButton>
                <AcceptButton type="button" onClick={handleAccept}>
                  {t('global.cookie.accept')}
                </AcceptButton>
              </Actions>
            </Margin>
          </Col>
        </Row>
      </Container>
    </Wrapper>
  );
};

export default Cookie;
